import React from "react";
import "./returnsignin.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ReturnSignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const { key } = location.state || {};

  const handlereturn_signin = () => {
    navigate("/signin");
  };
  return (
    <div className="signin-return">
      <div className="tvs-logo">
        <img height='80px' width= '294px' src={Image_Url.TVSLOGO} alt="" />
      </div>
      {key === "reset_password" ? (
        <div className="reset-password-confirmation-container">
          <h2>{t('returnsignin.resetsuccess')}</h2>
          <p>{t('returnsignin.successfulresettext')}</p>
          <p>{t('returnsignin.signinwithnewpass')}</p>
          <span onClick={handlereturn_signin}>{t('returnsignin.returntosignin')}</span>
        </div>
      ) : (
        <div className="reset-password-confirmation-container">
            <h2>{t('returnsignin.linksentsuccessful')}</h2>
          <p className="forget_popup">{t('returnsignin.checkemailtext')}</p>
            <p>{t('returnsignin.doesnotappeartext')}</p>
            <p>{t('returnsignin.checkspamfolder')}</p>
          <span onClick={handlereturn_signin}>{t('returnsignin.returntosignin')}</span>
        </div>
      )}
    </div>
  );
};

export default ReturnSignIn;
